import arrowLeft from "./icons/arrow-left.svg";
import bell from "./icons/bell.svg";
import chevronRight12 from "./icons/chevron-right-12.svg";
import chevronRight15 from "./icons/chevron-right-15.svg";
import circleCheck from "./icons/circle-check.svg";
import clipboardList from "./icons/clipboard-list.svg";
import download from "./icons/download.svg";
import ellipsis from "./icons/ellipsis.svg";
import info from "./icons/info.svg";
import pencil from "./icons/pencil.svg";
import plus from "./icons/plus.svg";
import receiptText from "./icons/receipt-text.svg";
import route from "./icons/route.svg";
import search from "./icons/search.svg";
import shieldCheck from "./icons/shield-check.svg";

/**
 * Figma icon assets for the jobs v2 workspace.
 * Each file keeps the width and height exported from the design.
 * @type {Record<string, string>}
 */
export const jobWorkspaceIcons = {
  arrowLeft,
  bell,
  chevronRight12,
  chevronRight15,
  circleCheck,
  clipboardList,
  download,
  ellipsis,
  info,
  pencil,
  plus,
  receiptText,
  route,
  search,
  shieldCheck,
};

/**
 * Renders a jobs workspace icon at its exported size.
 * @param {{ name: keyof typeof jobWorkspaceIcons, alt?: string }} props
 * @returns {JSX.Element}
 */
export function JobWorkspaceIcon({ name, alt = "" }) {
  return (
    <img
      src={jobWorkspaceIcons[name]}
      alt={alt}
      className="block shrink-0"
    />
  );
}
